import { render, staticRenderFns } from "./ClientsListFilter.vue?vue&type=template&id=4ac34c47"
import script from "./ClientsListFilter.vue?vue&type=script&lang=js"
export * from "./ClientsListFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports